import { accountIdFormat } from "@redotech/redo-account-id";
import * as z from "zod";

export const listManagedMerchantStores = {
  name: "listManagedMerchantStores" as const,
  input: z.object({}),
  output: z.object({
    stores: z.array(
      z.object({ accountId: accountIdFormat.schema, storeName: z.string() }),
    ),
  }),
};
